"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnWayDateEditor = exports.departingLabel = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const DateRange_1 = require("../../../Form/Field/DateRange");
exports.departingLabel = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/Departing:label', defaultMessage: 'Departing' }));
const returningLabel = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Front/SearchForm/To:Returning', defaultMessage: 'Returning' }));
const ReturnWayDateEditor = (props) => {
    const { departing, returning } = props;
    const rangeProps = {
        fromField: {
            value: departing.value,
            setValue: departing.onValue,
            error: departing.error,
            modificators: departing.modifiers,
            label: exports.departingLabel,
            name: 'departing',
        },
        toField: {
            value: returning.value,
            setValue: returning.onValue,
            error: returning.error,
            modificators: returning.modifiers,
            label: returningLabel,
            name: 'returning',
        },
        restrictions: {
            disablePastDays: true,
            pastYearsCount: dateTime_1.bookingPastYearsCount,
            nextYearsCount: dateTime_1.bookingNextYearsCount,
        },
    };
    return (react_1.default.createElement(DateRange_1.FormFieldDateRange, { ...rangeProps }));
};
exports.ReturnWayDateEditor = ReturnWayDateEditor;
//# sourceMappingURL=ReturnWayDateEditor.js.map